var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCityBikeStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-label": "parkering",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#008a34",
    fillRule: "evenodd",
    d: "M3.2 0h17.6A3.2 3.2 0 0124 3.2v17.6a3.2 3.2 0 01-3.2 3.2H3.2A3.2 3.2 0 010 20.8V3.2A3.2 3.2 0 013.2 0zm3.2 4v16.24h3.41v-5.591h2.506c3.364 0 6.287-1.508 6.287-5.336 0-3.805-2.9-5.313-6.287-5.313H6.4zm5.986 7.68H9.81V6.945h2.576c1.252 0 2.621.604 2.621 2.367 0 1.786-1.369 2.366-2.621 2.366z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityBikeStop);
export default __webpack_public_path__ + "static/media/cityBikeStop.5eaa0459.svg";
export { ForwardRef as ReactComponent };